import React from "react";
import { Box, Typography } from "@mui/material";

const ServiceDescription: React.FC = () => {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h6" fontWeight="bold" gutterBottom>
        Service Description
      </Typography>

      <Typography variant="body2" paragraph sx={{ mt: 2 }}>
        Please accept our deepest condolences during this difficult time. We are
        honored that you have chosen Muzukuru to help you celebrate the life of
        Jane Doe The following proposal outlines our recommended services to
        create a meaningful and personalized tribute that honors their memory
        and provides comfort to your family and friends.
      </Typography>
    </Box>
  );
};

export default ServiceDescription;
